function decimalCount(number) {
	// Convert to String
	const numberAsString = number.toString();
	// String Contains Decimal
	if (numberAsString.includes('.')) {
		return numberAsString.split('.')[1].length;
	}
	// String Does Not Contain Decimal
	return 0;
}

$(document).ready(function() {
	
	// blog posts carousel
	if ($('.icon-blog-posts-carousel').length > 0) { 
		$('.icon-blog-posts-carousel').each(function(index, group) {
			var count = $('.icon-blog-post-card', group).length;
			if (count > 3) {
				var carousel = $(group).flickity({
					adaptiveHeight: false,
					arrowShape: 'm51.4 101.1c24.6.2 45.9-17.2 50.6-41.3h-61.3l31.4 30.7-27 .2-40.4-40.4 39.5-40.1h27l-29.7 30.7h60.4c-4.4-23.2-25.2-39.9-50.5-39.9-27.9-.4-50.9 21.9-51.4 50 .3 28.1 23.3 50.5 51.3 50.1z',
					cellAlign: 'left',
					pageDots: false,
					percentPosition: true,
					watchCSS: true,
					wrapAround: true
				});
			}
		});
	}
	
	// logos carousel 
	if ($('.icon-logos-carousel').length > 0) {
		$('.icon-logos-carousel').each(function(index, group) {
			var count = $('.icon-logo', group).length;
			if (count > 3) {
				var carousel = $(group).flickity({
					adaptiveHeight: false,
					cellAlign: 'left',
					pageDots: true,
					percentPosition: true,
					prevNextButtons: false,
					watchCSS: true,
					wrapAround: true
				});
			}
		});
	}
	
	// categories dropdown menu
	$('#icon-categories-select').on('change', function() {
		var url = $(this).val();
		console.log('hello!', url);
		window.location.href = url;
	});
	
	// newsletter signup form
	$('#icon-newsletter-form').validate({
		// debug: true,
		errorElement: 'span',
		errorClass: 'form-field-error',
		validClass: 'form-field-valid',
		errorPlacement: function (error, element) {
			error.appendTo(element.parents('form'));
		},
		highlight: function (element, errorClass, validClass) {
			$(element).parents('form').addClass(errorClass).removeClass(validClass);
		},
		unhighlight: function (element, errorClass, validClass) {
			$(element).parents('form').removeClass(errorClass).addClass(validClass);
		},
		rules: {
			'newsletter-email-address': {
				required: true,
				email: true
			},
			'newsletter-consent': {
				required: true
			}
		},
		messages: {
			'newsletter-email-address': {
				required: 'Please enter your email address.',
				email: 'Please enter a valid email address.'
			},
			'newsletter-consent': {
				required: 'Please check the box to consent to recieving email communications from Icon Parking.'
			}
		},
		submitHandler: function(form) {
			$('.button-spinner', form).prop('disabled', true);
			alert('This newsletter form needs to be hooked up to something.');
			$('.button-spinner', form).prop('disabled', false);
		}
	});
	
	// statistics animated numbers
	if ($('.icon-statistics-group').length > 0) {
		$('.icon-statistics-group').each(function(index, group) {
			var squares = $('.icon-statistic', group);
			$(squares).each(function(index, square) {
				var target = $('.icon-statistic-number', square)[0];
				var number = $(target).attr('data-number');
				var decimals = decimalCount(number);
				var prefix = $(target).attr('data-prefix');
				var suffix = $(target).attr('data-suffix');
				var options = {
					startVal: 0,
					decimalPlaces: decimals,
					duration: 5,
					useGrouping: true,
					useEasing: true,
					prefix: prefix,
					suffix: suffix,
					enableScrollSpy: true,
					scrollSpyOnce: true
				};
				var counter = new CountUp(target, number, options);
			});
		});
	}
	
	// frequently asked questions autocomplete search box
	if ($('#search-faqs').length) {
		$.ajax({
			type: 'post',
			url: '/wp-admin/admin-ajax.php',
			data: {
				action: 'icon_get_faqs'
			},
			success: function(results) {
				var results = JSON.parse(results);
				console.log(results);
				if (results.status === 'success') {
					$('#search-faqs').autocomplete({
						lookup: results.suggestions,
						onSelect: function(suggestion) {
							window.location.href = '/faqs/#faq-' + suggestion.data.id;
							$('#faq-' + suggestion.data.id).addClass('icon-accordion-card-active');
						}
					});
				}
			},
			error: function(results) {
				console.log(results);
			}
		});	
	}
	
	if ($('body').hasClass('post-type-archive-faqs')) {
		var hash = window.location.hash;
		$(hash).addClass('icon-accordion-card-active');
	}
	
	// open and close frequently asked questions
	$('.icon-accordion-card .icon-faq-card-question').on('click', function() {
		$(this).parent().toggleClass('icon-accordion-card-active');
	});
	
	// show and hide form fields depending on parking type choice
	function syncParkingTypeFields(form) {
		var type = $('input[name="parking-type"]:checked', form).val();
		if (type === 'hourly') {
			$('.icon-find-parking-form-field-monthly', form).hide();
			$('.icon-find-parking-form-field-hourly', form).show();
		} else if (type === 'monthly') {
			$('.icon-find-parking-form-field-hourly', form).hide();
			$('.icon-find-parking-form-field-monthly', form).show();
		}
	}
	$('.icon-find-parking-form input[name="parking-type"]').on('change', function() {
		syncParkingTypeFields(this.form);
	});

	function restoreParkingSearchForms() {
		$('.icon-find-parking-form').each(function(index, form) {
			$('.button-spinner', form).prop('disabled', false);
			syncParkingTypeFields(form);
		});
	}
	// Back/Forward may restore the disabled submit button without rerunning ready.
	$(window).on('pageshow', restoreParkingSearchForms);
	restoreParkingSearchForms();
	
	$('.icon-find-parking-form').each(function(index, form) {
		
		// enable autocomplete address field
		var autocomplete_input = $('input[name="address"]', form)[0];
		var autocomplete_options = {
			componentRestrictions: {
				country: ['us']
			}
		};
		var autocomplete = new google.maps.places.Autocomplete(autocomplete_input, autocomplete_options);
		function clearAddressSelection() {
			$(autocomplete_input)
				.removeAttr('data-latitude data-longitude data-offset')
				.attr('data-place-selected', 'false');
		}
		autocomplete.addListener('place_changed', function () {
			var place = autocomplete.getPlace();
			// Autocomplete can return only the entered text, without place details.
			// Never reuse coordinates from a previous selection in that case.
			clearAddressSelection();
			if (!place || !place.place_id || !place.geometry || !place.geometry.location) {
				$(autocomplete_input).valid();
				return;
			}
			var lat = place.geometry.location.lat();
			var lng = place.geometry.location.lng();
			if (!Number.isFinite(lat) || !Number.isFinite(lng) || !Number.isFinite(place.utc_offset_minutes)) {
				$(autocomplete_input).valid();
				return;
			}
			// convert offset to seconds
			var offset = place.utc_offset_minutes * 60;
			$(autocomplete_input).attr({
				'data-latitude': lat,
				'data-longitude': lng,
				'data-offset': offset,
				'data-place-selected': 'true'
			});
			$(autocomplete_input).valid();
		});
		
		// Editing a selected address invalidates its coordinates as well as its label.
		$(autocomplete_input).on('input', clearAddressSelection);
		
		// validate hourly dates and times
		$('select[name="start-date-hourly"], select[name="start-time-hourly"], select[name="end-date-hourly"], select[name="end-time-hourly"]', form).on('change', function() {
			
			const start_date = $('select[name="start-date-hourly"]', form).val();
			const start_time = $('select[name="start-time-hourly"]', form).val();
			const end_date = $('select[name="end-date-hourly"]', form).val();
			const end_time = $('select[name="end-time-hourly"]', form).val();
			
			const start_object = moment(start_date + ' ' + start_time, 'YYYY-MM-DD HH:mm');
			const end_object = moment(end_date + ' ' + end_time, 'YYYY-MM-DD HH:mm');
			
			if (end_object.isBefore(start_object) || start_object.isSame(end_object)) {
				let new_end_object = moment(start_date + ' ' + start_time, 'YYYY-MM-DD HH:mm');
				new_end_object.add(3, 'hours');
				$('select[name="end-date-hourly"]', form).val(new_end_object.format('YYYY-MM-DD'));
				$('select[name="end-time-hourly"]', form).val(new_end_object.format('HH:mm'));
			}
			
		});
		
		// submit the form
		$(form).validate({
			// debug: true,
			errorElement: 'span',
			errorClass: 'icon-find-parking-form-field-error',
			validClass: 'icon-find-parking-form-field-valid',
			errorPlacement: function (error, element) {
				error.appendTo(element.parents('.icon-find-parking-form-field'));
			},
			highlight: function (element, errorClass, validClass) {
				$(element).parents('.icon-find-parking-form-field').addClass(errorClass).removeClass(validClass);
			},
			unhighlight: function (element, errorClass, validClass) {
				$(element).parents('.icon-find-parking-form-field').removeClass(errorClass).addClass(validClass);
			},
			rules: {
				'parking-type': {
					required: true
				},
				'address': {
					required: true,
					google_place_selected: true
				},
				'start-date-hourly': {
					required: function(element) {
						return $('input[name="parking-type"]:checked', form).val() === 'hourly';
					}
				},
				'start-time-hourly': {
					required: function(element) {
						return $('input[name="parking-type"]:checked', form).val() === 'hourly';
					}
				},
				'end-date-hourly': {
					required: function(element) {
						return $('input[name="parking-type"]:checked', form).val() === 'hourly';
					}
				},
				'end-time-hourly': {
					required: function(element) {
						return $('input[name="parking-type"]:checked', form).val() === 'hourly';
					}
				},
				'start-time-monthly': {
					required: function(element) {
						return $('input[name="parking-type"]:checked', form).val() === 'monthly';
					}
				}
			},
			messages: {
				'parking-type': {
					required: 'Please choose a parking type.'
				},
				'address': {
					required: 'Please choose a place, address, or landmark.',
					google_place_selected: 'Please select a valid location from the dropdown.'
				},
				'start-date-hourly': {
					required: 'Please choose an entrance date.'
				},
				'start-time-hourly': {
					required: 'Please choose an entrance time.'
				},
				'end-date-hourly': {
					required: 'Please choose an exit date.'
				},
				'end-time-hourly': {
					required: 'Please choose an exit time.'
				},
				'start-date-monthly': {
					required: 'Please choose an entrance date.'
				}
			},
			submitHandler: function(form) {
				$('.button-spinner', form).prop('disabled', true);
				var parking_type = $('input[name="parking-type"]:checked', form).val();
				var latitude = $('input[name="address"]', form).attr('data-latitude'); 
				var longitude = $('input[name="address"]', form).attr('data-longitude'); 
				var address = $('input[name="address"]', form).val();
				console.log('address =', address);
				var offset = $('input[name="address"]', form).attr('data-offset');
				if (parking_type === 'hourly') {
					var start_date = $('select[name="start-date-hourly"]', form).find(':selected').val();
					var start_time = $('select[name="start-time-hourly"]', form).find(':selected').val();
					var end_date = $('select[name="end-date-hourly"]', form).find(':selected').val();
					var end_time = $('select[name="end-time-hourly"]', form).find(':selected').val();
				} else if (parking_type === 'monthly') {
					var start_date = $('select[name="start-date-monthly"]', form).find(':selected').val();
				}
				// build url for search results
				var url = new URL('/search/', window.location.href);
				url.searchParams.set('type', parking_type);
				url.searchParams.set('lat', latitude);
				url.searchParams.set('lng', longitude);
				url.searchParams.set('address', encodeURIComponent(address));
				if (parking_type === 'hourly') {
					url.searchParams.set('startDate', start_date);
					url.searchParams.set('startTime', start_time);
					url.searchParams.set('endDate', end_date);
					url.searchParams.set('endTime', end_time);
				} else if (parking_type === 'monthly') {
					url.searchParams.set('startDate', start_date);
					url.searchParams.set('startTime', '23:59');
				}
				url.searchParams.set('offset', offset);
				var url_string = url.toString();
				// console.log(url_string);
				window.location.href = url_string;
			}
		});
	});
	
});
